"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _PasswordForgottenStepOne = _interopRequireDefault(require("../../components/PasswordForgottenPageConfirmation/PasswordForgottenStepOne"));
var _PasswordForgottenStepThree = _interopRequireDefault(require("../../components/PasswordForgottenPageConfirmation/PasswordForgottenStepThree"));
var _LinkExpired = _interopRequireDefault(require("../../components/LinkExpired/LinkExpired"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PasswordForgottenPageConfirmation = /*#__PURE__*/function (_React$Component) {
  function PasswordForgottenPageConfirmation(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PasswordForgottenPageConfirmation);
    _this = _callSuper(this, PasswordForgottenPageConfirmation, [props]);
    _this.state = {
      currentStep: 1,
      isLoading: false
    };
    _this.handleGoToLogin = _this.handleGoToLogin.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(PasswordForgottenPageConfirmation, _React$Component);
  return (0, _createClass2.default)(PasswordForgottenPageConfirmation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var code = window.location.hash.substr(1);
      if (code === 'success') {
        this.setState({
          currentStep: 3
        });
      } else if (code === 'expired') {
        this.setState({
          currentStep: 4
        });
      }
    }
  }, {
    key: "handleGoToLogin",
    value: function handleGoToLogin() {
      window.location.replace(_ciamAuthWebClientLib.SessionHandler.generateCiamLoginUrl());
    }
  }, {
    key: "render",
    value: function render() {
      var currentStep = this.state.currentStep;
      var loading = this.state.isLoading;
      return /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
        loading: loading,
        fallbackGifSrc: localStorage.fallbackLoader
      }, currentStep === 4 ? /*#__PURE__*/_react.default.createElement(_LinkExpired.default, this.props.expired) : /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix form-wrapper form-wrapper--has-shadow csc-reset-password"
      }, currentStep === 1 && /*#__PURE__*/_react.default.createElement(_PasswordForgottenStepOne.default, {
        title: this.props.stepOne.title,
        titleText: this.props.stepOne.titleText,
        titleSubHeading: this.props.stepOne.titleSubHeading,
        stepOneTitle: this.props.stepOne.stepTitle,
        stepOneDesc: this.props.stepOne.stepDesc,
        stepTwoTitle: this.props.stepTwo.stepTitle,
        stepTwoDesc: this.props.stepTwo.stepDesc,
        stepThreeTitle: this.props.stepThree.stepTitle,
        stepThreeDesc: this.props.stepThree.stepDesc
      }), currentStep === 3 && /*#__PURE__*/_react.default.createElement(_PasswordForgottenStepThree.default, {
        title: this.props.stepThree.title,
        titleText: this.props.stepThree.titleText,
        titleSubHeading: this.props.stepThree.titleSubHeading,
        buttonLabel: this.props.stepThree.buttonLabel,
        buttonVersion: this.props.buttonVersion,
        handleGoToLogin: this.handleGoToLogin,
        stepOneTitle: this.props.stepOne.stepTitle,
        stepOneDesc: this.props.stepOne.stepDesc,
        stepTwoTitle: this.props.stepTwo.stepTitle,
        stepTwoDesc: this.props.stepTwo.stepDesc,
        stepThreeTitle: this.props.stepThree.stepTitle,
        stepThreeDesc: this.props.stepThree.stepDesc
      })));
    }
  }]);
}(_react.default.Component);
PasswordForgottenPageConfirmation.propTypes = {
  stepOne: _propTypes.default.shape({
    title: _propTypes.default.string,
    titleText: _propTypes.default.string,
    titleSubHeading: _propTypes.default.string,
    stepTitle: _propTypes.default.string,
    stepDesc: _propTypes.default.string
  }).isRequired,
  stepTwo: _propTypes.default.shape({
    title: _propTypes.default.string,
    titleText: _propTypes.default.string,
    titleSubHeading: _propTypes.default.string,
    buttonLabel: _propTypes.default.string,
    stepTitle: _propTypes.default.string,
    stepDesc: _propTypes.default.string
  }).isRequired,
  stepThree: _propTypes.default.shape({
    title: _propTypes.default.string,
    titleText: _propTypes.default.string,
    titleSubHeading: _propTypes.default.string,
    buttonLabel: _propTypes.default.string,
    stepTitle: _propTypes.default.string,
    stepDesc: _propTypes.default.string
  }).isRequired,
  buttonVersion: _propTypes.default.string,
  validationState: _propTypes.default.object,
  // eslint-disable-line
  expired: _propTypes.default.object // eslint-disable-line
};
var _default = exports.default = PasswordForgottenPageConfirmation;